export const TABLE_ROW_COLORS = {
  yellow: 'yellow',
  green: 'green',
  red: 'red'
} as const
